import { motion } from "framer-motion"
import { useRef } from "react";

type TabOption = {
  value: string;
  label: string;
}

type TabsProps = {
  type?: "primary" | "secondary";
  color?: string;
  options: TabOption[];
  value: string;
  onChange: (value: string) => void;
}

export const Tabs = ({ type = "primary", color, options, value, onChange }: TabsProps) => {
  const refKey = useRef(`tab-indicator-${Date.now()}-${Math.random()}`)

  return (
    <div className={`flex justify-start items-start w-full p-0.5 rounded-lg bg-[#212425]`}>
      {options.map((option) => (
        <button
          key={option.value}
          onClick={() => onChange(option.value)}
          className="relative flex-1"
        >
          {value === option.value && (
            <motion.div 
              layoutId={refKey.current}
              className="absolute inset-0 flex justify-start items-start flex-grow">
              <div className={`flex justify-center items-center flex-grow h-10 relative px-3 rounded-lg bg-[#60e25e]/[0.15]`} style={color ? { background: color } : {}}/>
            </motion.div>
          )}
          <div className="relative z-10 flex justify-center items-center flex-grow h-10 px-3 rounded-lg">
            <p className={`flex-grow-0 flex-shrink-0 text-[13px] font-bold text-left transition-colors ${value === option.value ? 'text-[#60e25e]' : 'text-[#9c9e9e]'}`}>
              {option.label}
            </p>
          </div>
        </button>
      ))}
    </div>
  )
}